export default function downloadQRCode() {
    const canvas = document.getElementById('qr-canvas');
    const url = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = url;
    link.download = 'qrcode.png';
    link.click();
}